import React from "react";
import Layout from "../../../../components/layout";
import ApmNavbar from "../../../../components/navbar-apm";
import FeatureMenu from "../../../../components/feature-menu";

const Page = () => (
  <Layout title="APM Features" hasSubNav={true}>
    <ApmNavbar selection="features" />

    <div className="container apm-features">
      <div className="columns">
        <FeatureMenu active="alerts" />

        <div className="column feature-content">
          <div className="tab-pane fade" id="alerts">
            <h3>ALERTS</h3>
            <div className="grid-container features-container alerts-gallery">
              <div className="img-wrap item-a">
                <a href="/img/apm/features/alerts1.png" rel="alternate">
                  <img src="/img/apm/features/alerts1.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-a">
                <h4>Alerts for everything</h4>
                <h4>
                  <span>From Applications to individual Transactions. Alerts across your entire infrastructure.</span>
                </h4>
              </div>
              <div className="img-wrap item-b">
                <a href="/img/apm/features/alerts2.png" rel="alternate">
                  <img src="/img/apm/features/alerts2.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-b">
                <h4>Integrates with everything</h4>
                <h4>
                  <span>Whatever your favorite tool, DripStat integrates with it.</span>
                </h4>
              </div>
            </div>
            <div className="grid-container features-container alerts-gallery">
              <div className="img-wrap item-a">
                <a href="/img/apm/features/alerts3.png" rel="alternate">
                  <img src="/img/apm/features/alerts3.png" alt="" />
                </a>
              </div>
              <div className="text-wrap item-a">
                <h4>No Alert Fatigue</h4>
                <h4>
                  <span>Violations for a policy are rolled up into Incidents. Reduce alert fatigue. Easily track root cause of multiple simultaneous alerts in a single location.</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default Page;
